import { render } from "./LoadingSpinner.vue?vue&type=template&id=2a64bc2a&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=2a64bc2a&lang=scss&scoped=true"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a64bc2a"]])

export default __exports__